'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);

var _ProjectSummary = require('../ProjectDetailedInfo/ProjectSummary/ProjectSummary');var _ProjectSummary2 = _interopRequireDefault(_ProjectSummary);

var _getMapUrl = require('../../utils/getMapUrl');var _getMapUrl2 = _interopRequireDefault(_getMapUrl);
var _constants = require('../../constants');
var _formatPhoneNumber = require('../../utils/formatPhoneNumber');
var _checkers = require('../../utils/checkers');
var _pin = require('../../../static/icons/pin.svg');var _pin2 = _interopRequireDefault(_pin);

var _ProjectDetailsPrintPage = require('../ProjectDetailsPrintPage/ProjectDetailsPrintPage.scss');var _ProjectDetailsPrintPage2 = _interopRequireDefault(_ProjectDetailsPrintPage);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // components
// helpers
// styles
var ProjectDetailsPrintPage = function (_Component) {_inherits(ProjectDetailsPrintPage, _Component);function ProjectDetailsPrintPage() {var _temp, _this, _ret;_classCallCheck(this, ProjectDetailsPrintPage);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
























    closePrintPage = function () {return _this.props.hidePrintPage();}, _this.

    printWatcher = function (mql) {return mql && !mql.matches && _this.closePrintPage();}, _this.

    renderAddress = function (_ref) {var city_name = _ref.city_name,neighborhood = _ref.neighborhood,street_name = _ref.street_name,house_number = _ref.house_number;
      var formattedNeighborhood = city_name === neighborhood ? '' : neighborhood + ',';
      return (
        _react2.default.createElement('span', null, street_name, ' ', house_number, ', ', city_name, ' ', formattedNeighborhood));

    }, _this.

    renderContacts = function (translate, contacts, name) {return (
        _react2.default.createElement('div', { className: _ProjectDetailsPrintPage2.default.contacts },
          _react2.default.createElement('div', null,
            _react2.default.createElement('div', { className: _ProjectDetailsPrintPage2.default.title },
              _react2.default.createElement('span', { className: _ProjectDetailsPrintPage2.default.colorBlue }, translate('contacts', 'title'))),


            name &&
            _react2.default.createElement('div', { className: _ProjectDetailsPrintPage2.default.name },
              _react2.default.createElement('div', { className: _ProjectDetailsPrintPage2.default.iconContainer },
                _react2.default.createElement('i', { className: 'icon icon-office' })),

              _react2.default.createElement('span', null, name)),


            contacts.phoneNumber &&
            _react2.default.createElement('div', { className: _ProjectDetailsPrintPage2.default.contactData },
              _react2.default.createElement('div', { className: _ProjectDetailsPrintPage2.default.iconContainer },
                _react2.default.createElement('i', { className: 'icon icon-phone' })),

              _react2.default.createElement('span', null, (0, _formatPhoneNumber.formatPhoneNumber)((0, _formatPhoneNumber.clearPhoneNumber)(contacts.phoneNumber)))),


            contacts.email && !(0, _checkers.isTemporaryEmail)(contacts.email) &&
            _react2.default.createElement('div', { className: _ProjectDetailsPrintPage2.default.contactData },
              _react2.default.createElement('div', { className: _ProjectDetailsPrintPage2.default.iconContainer },
                _react2.default.createElement('i', { className: 'icon icon-mail' })),

              _react2.default.createElement('span', null, contacts.email)))));}, _this.





    render = function () {var _cx;var _this$props =
      _this.props,data = _this$props.data,isRtl = _this$props.isRtl,locale = _this$props.locale,translate = _this$props.translate,contacts = _this$props.contacts;var
      address = data.address,images = data.images,description = data.description,name = data.name,commodities = data.commodities;
      var hasPropertyImage = !!(images && images.length);
      var localisedAddress = address[locale] || address.he;
      var localisedDescription = description[locale] || description.he;
      var localisedName = name[locale] || name.he;

      return (
        _react2.default.createElement('div', { className: (0, _classnames2.default)(_ProjectDetailsPrintPage2.default.projectDetailsPrintPage, { rtl: isRtl }) },
          _react2.default.createElement('div', { className: (0, _classnames2.default)(_ProjectDetailsPrintPage2.default.row, _ProjectDetailsPrintPage2.default.fillSpace, _ProjectDetailsPrintPage2.default.header) },
            _this.renderAddress(Object.assign({}, localisedAddress)),
            _react2.default.createElement('img', {
              width: '88px',
              src: _constants.onMapLogoBlue,
              alt: '',
              title: '' + _this.props.translate('header', 'onMapHomepage') })),



          _react2.default.createElement('hr', null),

          _react2.default.createElement('div', { className: (0, _classnames2.default)(_ProjectDetailsPrintPage2.default.row, _ProjectDetailsPrintPage2.default.padded, _ProjectDetailsPrintPage2.default.fillSpace) },
            hasPropertyImage &&
            _react2.default.createElement('img', { src: images[0], alt: '' }),

            _react2.default.createElement('div', { className: (0, _classnames2.default)(_ProjectDetailsPrintPage2.default.mapContainer, (_cx = {}, _cx[_ProjectDetailsPrintPage2.default.onlyMap] = !hasPropertyImage, _cx)) },
              _react2.default.createElement('img', { src: (0, _getMapUrl2.default)(address.location, locale, hasPropertyImage), alt: 'map', className: _ProjectDetailsPrintPage2.default.mapImage }),
              _react2.default.createElement('img', { src: _pin2.default, alt: 'pin', className: _ProjectDetailsPrintPage2.default.mapPin }))),



          _react2.default.createElement('hr', null),

          _react2.default.createElement('div', { className: (0, _classnames2.default)(_ProjectDetailsPrintPage2.default.row, _ProjectDetailsPrintPage2.default.padded, _ProjectDetailsPrintPage2.default.fillSpace) },
            _react2.default.createElement('div', { className: _ProjectDetailsPrintPage2.default.summaryWrapper },
              _react2.default.createElement(_ProjectSummary2.default, {
                translate: _this.props.translate,
                name: localisedName,
                shortDescription: _this.props.summary,
                address: localisedAddress,
                price: data.min_property_price,
                status: status,
                completionDate: data.completion_date,
                currency: data.currency,
                propertyTypes: _this.props.propertyTypes,
                rooms: data.room_range.join(', '),
                hideLogo: true,
                locale: locale || 'he' })),


            _this.renderContacts(translate('propertyDetails'), contacts, localisedName)),



          localisedDescription &&
          _react2.default.createElement('div', null,
            _react2.default.createElement('hr', null),

            _react2.default.createElement('div', { className: (0, _classnames2.default)(_ProjectDetailsPrintPage2.default.row, _ProjectDetailsPrintPage2.default.padded) },
              _react2.default.createElement('div', { className: _ProjectDetailsPrintPage2.default.rowTitle },
                translate('propertyDetails', 'description')),

              _react2.default.createElement('pre', null, localisedDescription))),




          !!commodities.length &&
          _react2.default.createElement('div', null,
            _react2.default.createElement('hr', null),
            _react2.default.createElement('div', { className: (0, _classnames2.default)(_ProjectDetailsPrintPage2.default.row, _ProjectDetailsPrintPage2.default.padded) },
              _react2.default.createElement('div', { className: _ProjectDetailsPrintPage2.default.rowTitle },
                translate('ProjectDetails', 'onTheProject')),

              _react2.default.createElement('div', null,
                commodities.map(function () {var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};return (
                    _react2.default.createElement('div', { key: item.type },
                      _react2.default.createElement('div', null, translate('addNewProject', (0, _get2.default)(item, 'type', 'extras'))),
                      _react2.default.createElement('ul', null,
                        (0, _get2.default)(item, 'items', []).map(function (commodity) {return (
                            _react2.default.createElement('li', { key: commodity }, commodity));}))));}))))));










    }, _temp), _possibleConstructorReturn(_this, _ret);}ProjectDetailsPrintPage.prototype.componentWillMount = function componentWillMount() {if (global && global.window) {if (global.window.matchMedia) {this.mediaQueryList = window.matchMedia('print');this.mediaQueryList.addListener(this.printWatcher);}global.window.onafterprint = this.printWatcher;}};ProjectDetailsPrintPage.prototype.componentDidMount = function componentDidMount() {if (global && global.window) {setTimeout(window.print, 500);}};ProjectDetailsPrintPage.prototype.componentWillUnmount = function componentWillUnmount() {if (global.window) {if (this.mediaQueryList) {this.mediaQueryList.removeListener(this.printWatcher);}global.window.onafterprint = null;}};return ProjectDetailsPrintPage;}(_react.Component);


ProjectDetailsPrintPage.propTypes = {
  data: _propTypes2.default.object,
  isRtl: _propTypes2.default.bool,
  locale: _propTypes2.default.string,
  translate: _propTypes2.default.func,
  hidePrintPage: _propTypes2.default.func,
  contacts: _propTypes2.default.object,
  summary: _propTypes2.default.string,
  propertyTypes: _propTypes2.default.string };exports.default =


ProjectDetailsPrintPage;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ProjectDetailsPrintPage/ProjectDetailsPrintPage.js
// module id = 2807
// module chunks = 0